import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M22.0312 9.5C22.0312 7.57 20.4612 6 18.5312 6C16.6013 6 15.0312 7.57 15.0312 9.5C15.0312 11.127 16.1532 12.487 17.6602 12.877V17.417C17.6602 18.841 16.5012 20 15.0772 20H13.0392C10.5592 20 8.54125 17.982 8.54125 15.502V13.556C11.1032 13.084 13.0522 10.838 13.0522 8.142V2H10.0312V4H11.0522V8.142C11.0522 10.078 9.47725 11.652 7.54125 11.652C5.60525 11.652 4.03125 10.078 4.03125 8.142V4H4.92525V2H2.03125V8.142C2.03125 10.838 3.97925 13.084 6.54125 13.556V15.502C6.54125 19.085 9.45625 22 13.0392 22H15.0772C17.6042 22 19.6602 19.944 19.6602 17.417V12.797C21.0342 12.324 22.0312 11.033 22.0312 9.5ZM18.5312 11C17.7042 11 17.0312 10.327 17.0312 9.5C17.0312 8.673 17.7042 8 18.5312 8C19.3583 8 20.0312 8.673 20.0312 9.5C20.0312 10.327 19.3583 11 18.5312 11Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconStethoscope = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconStethoscope.displayName = "IconStethoscope";

export { IconStethoscope };
